import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType, ApplicationAuthorizationActionType as AuthType } from '../constants';
import { getLoginType } from '~server/utils/auth.utils';
import { MarketDetectionUtil } from '~shared/utils/market-detection.util';

export class AuthorizationApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.Authorization;

  constructor(
    private action?: AuthType,
    private label?: string,
    private isHoreca?: boolean,
    private loginType = getLoginType(),
    private tenant = MarketDetectionUtil.getCountryCode()
  ) {}

  getPayload(): any {
    let horecaTag;
    if (this.isHoreca !== undefined) {
      horecaTag = this.isHoreca ? 'Yes' : 'n.a.';
    }

    return {
      event: 'Authorisation',
      category: 'Authorisation',
      action: this.action,
      label: this.label,
      horecaTag,
      loginType: this.loginType,
      tenant: this.tenant,
    };
  }
}
